export default __webpack_public_path__ + "static/media/WM0440.34I-43830_-26155_0.9bedee11.jpg";